module.exports = __webpack_public_path__ + "img/skl-connect.68b0f525.svg";